import React from "react";
import { FormLabel } from "react-bootstrap";
import CoverPhotoBaseURL from "../../../util/coverPhotoBaseURL";
import "./style.css";

function BookDetailsCard({ item }) {
  return (
    <>
      <div className="modal-body modal-body-flex">
        <>
          <img
            src={item?.coverimage && `${CoverPhotoBaseURL}${item?.coverimage}`}
            className="book-details-img"
          />
          <div className="book-details-container">
            <div>
              <FormLabel className="book-details-title">
                {item?.bookname}
              </FormLabel>
            </div>
            <div className="book-details-description-text ellipsis">
              <FormLabel className="book-details-description-text-concat">
                {item?.description}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style">
                Author:
              </FormLabel>
              <FormLabel>{item?.writername}</FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style">
                Genre:
              </FormLabel>
              <FormLabel>{item?.genre}</FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style">
                Publisher:
              </FormLabel>
              <FormLabel>
                {item?.publisher?.firstname} {item?.publisher?.lastname}
              </FormLabel>
            </div>
            <div className="d-flex flex-row">
              <FormLabel className="mr-3 book-details-text-style">
                Price:
              </FormLabel>
              <FormLabel>${item?.price}</FormLabel>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default BookDetailsCard;
